import axios from "axios";
import headerRequest from "../config/headers";

const API_URL = process.env.REACT_APP_API_URL_SST;
const prefix = 'type-behavior';
const url = window.location.pathname;
const commonParams = { url: url };

class TypeBehaviorService {
    async showAll() {
        const ruta = `${API_URL}/${prefix}`;
        const headers = await headerRequest();
        const params = { ...commonParams };
        return axios.get(ruta, {
            headers: headers,
            params: params,
        }).catch((error) => {
            return error;
        });
    }

    async saveOrUpdate(body) {
        const ruta = `${API_URL}/type-behavior`;
        const headers = await headerRequest();
        const params = { ...commonParams };
        return axios.post(ruta, body, {
            headers: headers,
            params: params,
        }).catch((error) => {
            return error;
        });
    }

    async showTypeBehaviorByPlant(id) {
        const ruta = `${API_URL}/${prefix}/plant/${id}`;
        const headers = await headerRequest();
        const params = { ...commonParams };
        return axios.get(ruta, {
            headers: headers,
            params: params,
        }).catch((error) => {
            return error;
        });
    }

    async getComportamientoPlanta(id_planta) {
        const ruta = `${API_URL}/${prefix}/plant-behavior/${id_planta}`;
        const headers = await headerRequest();
        const params = { ...commonParams };
        return axios.get(ruta, {
            headers: headers,
            params: params,
        }).catch((error) => {
            return error;
        });
    }

    async showCategoryByTypeBehavior(id_tipoComportamiento) {
        const ruta = `${API_URL}/${prefix}/category/${id_tipoComportamiento}`;
        const headers = await headerRequest();
        const params = { ...commonParams };
        return axios.get(ruta, {
            headers: headers,
            params: params,
        }).catch((error) => {
            return error;
        });
    }

    async saveOrUpdatePlantBehavior(body) {
        const ruta = `${API_URL}/type-behavior/plants`;
        const headers = await headerRequest();
        const params = { ...commonParams };
        return axios.post(ruta, body, {
            headers: headers,
            params: params,
        }).catch((error) => {
            return error;
        });
    }

    async getComportamientoGrupo(id_grupo) {
        const ruta = `${API_URL}/${prefix}/grupo-behavior/${id_grupo}`;
        const headers = await headerRequest();
        const params = { ...commonParams };
        return axios.get(ruta, {
            headers: headers,
            params: params,
        }).catch((error) => {
            return error;
        });
    }

    async saveOrUpdateGrupoBehavior(body) {
        const ruta = `${API_URL}/type-behavior/grupo`;
        const headers = await headerRequest();
        const params = { ...commonParams };
        return axios.post(ruta, body, {
            headers: headers,
            params: params,
        }).catch((error) => {
            return error;
        });
    }

    async saveOrUpdatePlantGrupo(body) {
        const ruta = `${API_URL}/type-behavior/groups`;
        const headers = await headerRequest();
        const params = { ...commonParams };
        return axios.post(ruta, body, {
            headers: headers,
            params: params,
        }).catch((error) => {
            return error;
        });
    }

    async getGrupoPlanta(id_planta) {
        const ruta = `${API_URL}/${prefix}/plant-grupo/${id_planta}`;
        const headers = await headerRequest();
        const params = { ...commonParams };
        return axios.get(ruta, {
            headers: headers,
            params: params,
        }).catch((error) => {
            return error;
        });
    }
}

export default new TypeBehaviorService();